<!-- SkyPlus Shared Header — dynamic menu + license expiry warnings -->

<!-- EXPIRED banner — full width, blocks page until renewed -->
<div *ngIf="showExpiredBanner" class="sp-license-expired-banner">
  <span class="material-icons">block</span>
  <span class="sp-banner-text">
    Your SkyPlus license has <strong>expired</strong>.
    Please contact <strong>SkyPlus Support</strong> to renew your license.
  </span>
  <span class="sp-banner-date" *ngIf="expiryDate">Expired: {{ expiryDate }}</span>
</div>

<!-- READ-ONLY banner — concurrent license seats exhausted (graceful view-only) -->
<div *ngIf="readOnly"
     style="display:flex;align-items:center;gap:10px;padding:8px 16px;background:#FFF3E0;color:#BF360C;border-bottom:1px solid #FF6D00;font-size:13px;">
  <span class="material-icons">visibility</span>
  <span>You are in <strong>view-only</strong> mode — the concurrent license limit has been reached.
    You can view, but creating and updating are disabled until a seat frees up.</span>
</div>

<!-- Main header -->
<header class="sp-header">
  <div class="sp-header-content">

    <!-- Logo -->
    <div class="sp-logo">
      <img
        [src]="sector.brand?.logoWhiteUrl || sector.brand?.logoUrl || 'assets/images/skyplus/logo.png'"
        [alt]="sector.brand?.productName || 'SkyPlus'"
        class="sp-logo-img">
    </div>

    <!-- Main Navigation — driven by MenuService.headerItems$.
         "My Work" / "My Tasks" is now a regular, toggleable HEADER menu item
         (menu_key 'my-work', route '/my-work'): admins enable/disable it from the
         Menu Manager. Its live pending-task badge is preserved here by matching on
         the route, so any header item pointing at /my-work shows the count. -->
    <nav class="sp-top-nav">
      <button
        *ngFor="let item of headerItems"
        class="sp-nav-item"
        [class.active]="isActive(item.route)"
        [class.sp-nav-locked]="item.locked"
        [title]="item.locked ? (item.label + ' — not in your plan (click to learn more)') : (item.route === '/my-work' ? 'My Work — tasks assigned to or claimable by you' : item.label)"
        (click)="onNavClick(item)">
        <span class="material-icons">{{ item.icon }}</span>
        <span class="nav-label">{{ item.label }}</span>
        <span class="material-icons sp-nav-lock" *ngIf="item.locked">lock</span>
        <span class="mw-nav-badge" *ngIf="item.route === '/my-work' && myWorkCount > 0">{{ myWorkCount }}</span>
      </button>
    </nav>

    <!-- Right section -->
    <div class="sp-header-right">

      <!-- License expiry badge (INFO / WARNING / ALERT / CRITICAL / URGENT) -->
      <div
        *ngIf="showExpiryBadge"
        class="sp-expiry-badge"
        [class.sp-expiry-pulse]="expiryWarningLevel === 'URGENT' || expiryWarningLevel === 'CRITICAL'"
        [style.background-color]="expiryBadge.bgColor"
        [style.color]="expiryBadge.textColor"
        [style.border-color]="expiryBadge.borderColor"
        [title]="'License expires: ' + expiryDate">
        <span class="material-icons sp-expiry-icon">{{ expiryBadge.icon }}</span>
        <span class="sp-expiry-text">{{ expiryLabel }}</span>
      </div>

      <!-- Sector pack switcher (hidden in client mode) -->
      <sp-sector-switcher></sp-sector-switcher>
      <!-- Fingerprint warning indicator -->
      <div *ngIf="fingerprintWarning" class="sp-fp-warning" title="License server verification issue — contact SkyPlus support">
        <span class="material-icons">verified_user</span>
      </div>
      
      <button class="sp-icon-btn"
            *spHasFeature="'aiChat'"
            (click)="openIntelligence()"
            title="Ask the assistant">
      <span class="material-icons">auto_awesome</span>
      </button>
      <button class="sp-icon-btn" title="Help" (click)="openHelp()" *ngIf="canSeeHelp">
        <span class="material-icons">help_outline</span>
      </button>
      <button class="sp-icon-btn" title="Notifications">
        <span class="material-icons">notifications</span>
      </button>

      <!-- User Menu -->
      <div class="sp-user-menu">
        <button class="sp-user-btn" (click)="toggleUserMenu($event)">
          <span class="sp-user-name">Hi, {{ userDisplayName }}</span>
          <div class="sp-user-avatar">{{ userInitials }}</div>
        </button>
        <div class="sp-user-dropdown" *ngIf="showUserMenu">
          <button class="sp-dropdown-item sp-dropdown-item--danger" (click)="logout()">
            <span class="material-icons">logout</span>Sign Out
          </button>
        </div>
      </div>

    </div>
  </div>
</header>

<!-- Sub-header warning bar (WARNING / ALERT levels — below header, dismissable) -->
<div
  *ngIf="(expiryWarningLevel === 'WARNING' || expiryWarningLevel === 'ALERT') && expiryDate"
  class="sp-expiry-subbar"
  [class.sp-expiry-subbar--alert]="expiryWarningLevel === 'ALERT'"
  [class.sp-expiry-subbar--warning]="expiryWarningLevel === 'WARNING'">
  <span class="material-icons">{{ expiryBadge.icon }}</span>
  <span>
    Your SkyPlus license expires on <strong>{{ expiryDate }}</strong>
    ({{ daysUntilExpiry }} days remaining). Please contact SkyPlus to renew.
  </span>
</div>

<!-- Showroom upsell modal — shown when a locked (TEASE) module is clicked -->
<div class="sp-teaser-backdrop" *ngIf="teaserItem" (click)="closeTeaser()">
  <div class="sp-teaser-modal" (click)="$event.stopPropagation()">
    <div class="sp-teaser-head">
      <span class="material-icons sp-teaser-lock">lock</span>
      <div>
        <div class="sp-teaser-title">{{ teaserItem.label }}</div>
        <div class="sp-teaser-tag">Premium add-on</div>
      </div>
      <button class="sp-teaser-x" (click)="closeTeaser()" title="Close">×</button>
    </div>
    <p class="sp-teaser-body">{{ teaserItem.teaser }}</p>
    <div class="sp-teaser-actions">
      <button class="sp-teaser-btn" (click)="closeTeaser()">Got it</button>
    </div>
  </div>
</div>